<template>
  <v-sheet
    color="transparent"
    min-width="300"
  >
    <v-form
      id="log_in_form"
      @submit.prevent="login"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-text-field
        filled
        color="primary"
        class="white--text"
        v-model="credentials.username"
        name="email"
        :rules="emailRules()"
        v-bind:label="$t('email')"
        required
      ></v-text-field>

      <v-text-field
        filled
        autocomplete="new-password"
        color="primary"
        :type="show ? 'text' : 'password'"
        v-model="credentials.inputP"
        :rules="passwordRules()"
        v-bind:label="$t('password')"
        :append-icon="show ? 'visibility' : 'visibility_off'"
        @click:append="show = !show"
        required
        @input="encrypt"
      ></v-text-field>
      <v-text-field
        dense
        outlined
        color="primary"
        class="d-none"
        id="website"
        v-model="credentials.honeypot"
        required
      ></v-text-field>
      <v-btn
        block
        x-large
        type="submit"
        color="primary"
        class="mb-3"
        :loading="loading"
        @click.prevent="login"
      >{{$t('login')}}</v-btn>
      <div class="mb-3 text-center">
        <a @click="$emit('forgot')">{{$t('forgotPassword')}}</a>
      </div>
      <!-- <div v-if="!hideRegisterLink" class="mt-2">
                <v-btn
                  block
                  outlined
                  color="white"
                  @click="$router.push({name:'Register'})"
                >{{$t('freeDemo')}}</v-btn>
                
      </div>-->
    </v-form>
  </v-sheet>
</template>

<script>
import jwtdecode from "jwt-decode";
import sha256 from "sha256";
export default {
  name: "LoginComponent",
  beforeRouteEnter(to, from, next) {
    document.body.className = "login";
    if (from.name !== "Login" && from.name !== null) {
      localStorage.removeItem("auth");
      localStorage.removeItem("user");
    }
    next(vm => {
      // access to component instance via `vm`
      if (localStorage.getItem("auth") != null) {
        vm.$router.push({ name: "Projects" });
      } else {
        next();
      }
    });
  },
  mounted() {
    let form = document.getElementById("log_in_form");
    var newScript = document.createElement("script");
    var inlineScript = document.createTextNode(
      "var __ss_noform = __ss_noform || [];\
    __ss_noform.push(['baseURI', 'https://app-3QNF04NCZU.marketingautomation.services/webforms/receivePostback/MzawMDGzMDO3BAA/']);\
    __ss_noform.push(['form','log_in_form', 'a2246a5c-b387-4bab-bf8a-a4fd11141522']);\
    __ss_noform.push(['submitType', 'manual']);"
    );
    newScript.appendChild(inlineScript);
    form.parentNode.insertBefore(newScript, form.nextSibling);

    let sharpspringElement = document.createElement("script");
    sharpspringElement.setAttribute(
      "src",
      "https://koi-3QNF04NCZU.marketingautomation.services/client/noform.js?ver=1.24"
    );
    newScript.parentNode.insertBefore(
      sharpspringElement,
      newScript.nextSibling
    );
  },
  components: {},
  data: () => {
    return {
      tab: null,
      show: false,
      loading: false,
      valid: false,
      credentials: {
        username: "",
        inputP: "",
        password: "",
        honeypot: "",
        ihubApplicationId: 2
      }
    };
  },
  methods: {
    changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
    },
    fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return (
          String.fromCodePoint(codepoint.split(" ")[0]) +
          String.fromCodePoint(codepoint.split(" ")[1])
        );
      }
      return String.fromCodePoint(codepoint);
    },
    login() {
      if (this.valid && this.$refs.form.validate()) {
        if (this.credentials.honeypot.length == 0) {
          this.loading = true;
          this.encrypt();
          if (localStorage.getItem("language") == null) {
            localStorage.setItem("language", "EN");
          }
          __ss_noform.push([
            "submit",
            null,
            "a2246a5c-b387-4bab-bf8a-a4fd11141522"
          ]);
          this.$http
            .login(this.credentials)
            .then(res => {
              if (res.data) {
                if (jwtdecode(res.data)["QRLOG"]) {
                  this.$noty.success('<i class="fas fa-check"></i>');
                  localStorage.setItem("auth", res.data);
                  localStorage.setItem("user", jwtdecode(res.data).name);

                  this.$router.go();
                } else {
                  this.$noty.error(this.$t("noaccess"));
                  this.loading = false;
                }
              } else {
                this.$noty.error(this.$t("userNotFound"));
                this.loading = false;
              }
            })
            .catch(err => {
              this.$noty.error(this.$t("error"));
              console.log(err);
              this.loading = false;
            });
        }
      }
    },
    emailRules() {
      return [
        v => !!v || `${this.$t("email")} ${this.$t("required")}`,
        v => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(v) || `${this.$t("email")} ${this.$t("invalid")}`;
        }
      ];
    },
    passwordRules() {
      return [v => !!v || `${this.$t("password")} ${this.$t("required")}`];
    },
    encrypt() {
      this.credentials.password = sha256(this.credentials.inputP);
    }
  },
  beforeCreate: function() {
    // document.body.className = "login";
  }
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/components/Pages/Authentication/Login.vue